import { render, staticRenderFns } from "./cell-ledger-name.vue?vue&type=template&id=232d1b64&scoped=true"
import script from "./cell-ledger-name.ts?vue&type=script&lang=ts&external"
export * from "./cell-ledger-name.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-ledger-name.vue?vue&type=style&index=0&id=232d1b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232d1b64",
  null
  
)

export default component.exports